import React from "react";
import { NormalizedCargoItem } from "../../../../../domain/models/cargo-model";
import styles from "./index.module.css";
import { SeparationStatus } from "../../../../../domain/models/inventory-reservation";
import { Button } from "@mui/material";

type Props = {
  items: NormalizedCargoItem[];
  onPrint: () => void;
};

export function ProgressBar({ items, onPrint }: Props) {
  const totalAmount = items.reduce((sum, item) => {
    return (sum += item.inventoryReservations?.length || 0);
  }, 0);
  const separatedAmount = items.reduce((sum, item) => {
    return (sum +=
      item.inventoryReservations?.filter(
        (res) => res.status === SeparationStatus.separated
      ).length || 0);
  }, 0);

  const displayMessage = () => {
    if (separatedAmount === 0) return "Não Iniciada";
    if (separatedAmount === totalAmount) return "Carga Separada";
    return "Em Separação";
  };

  return (
    <>
      <div className={styles.myProgress}>
        <div
          className={styles.myBar}
          style={{
            width: `${Math.round((separatedAmount / totalAmount) * 100)}%`,
          }}
        />
      </div>
      <div style={{ fontSize: "11px" }} className={styles.number}>
        {`${Math.round((separatedAmount / totalAmount) * 100)}%`}
      </div>
      <div style={{ fontSize: "11px" }}>{displayMessage()}</div>

      <Button variant="outlined" sx={{ width: "100%" }} onClick={onPrint}>
        Imprimir
      </Button>
    </>
  );
}
